// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';

export default function Development() {
  return <span>this page for development testing</span>;
}
